import React, { FC } from 'react';
import { BoxV2 as Box, Flex } from 'portal-commons';

interface DetailFieldProps {
  label: string;
  labelIcon?: React.ReactNode;
}

const DetailField: FC<DetailFieldProps> = ({ label, labelIcon, children }) => {
  const hasValue =
    children !== undefined && children !== null && children !== '';
  return (
    <Box>
      <Flex
        sx={{
          alignItems: 'center',
          gap: '4px',
          mb: '4px',
        }}
      >
        <Box
          sx={{
            fontSize: '12px',
            color: '#808789',
            textTransform: 'uppercase',
            lineHeight: 'normal',
            fontWeight: 'normal',
          }}
        >
          {label}
        </Box>
        {labelIcon}
      </Flex>
      <Box
        sx={{
          fontSize: '14px',
          color: '#313129',
          lineHeight: 'normal',
          wordBreak: 'break-word',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {hasValue ? children : 'N/A'}
      </Box>
    </Box>
  );
};

export default DetailField;
